"use client";
import React, { useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useRouter } from "next/router";
import styles from "./Loading.module.css";

const Loading = ({ isOpen, userStatus, tokenDetails, studentCode }: any) => {
  const router = useRouter();
  const SMS_PORTAL = process.env.RMS_SMS_PORTAL;

  useEffect(() => {
    if (!userStatus || !tokenDetails) return;

    const queryParams = new URLSearchParams({
      access_token: tokenDetails.access_token,
      refresh_token: tokenDetails.refresh_token,
    });
    if (studentCode) {
      queryParams.append("studentCode", studentCode);
    }

    const url = `${SMS_PORTAL}?${queryParams.toString()}`;
    const timeoutId = setTimeout(() => {
      router.push(url);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [isOpen, userStatus, tokenDetails, router]);

  // const handleUserPortal = () => {
  //   if (userStatus === "NEW_LEAD") {
  //     return "Apply portal";
  //   } else if (userStatus === "EXISTING_STUDENT") {
  //     return "Student portal";
  //   }
  // };

  return (
    <>
      <Modal
        show={isOpen}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
        dialogClassName={styles.modal}
        contentClassName={styles.modalContent}
      >
        <div className={styles.topContainer}>
          <div>
            <Spinner
              animation="border"
              variant="success"
              style={{ width: "50px", height: "50px" }}
            />
          </div>
          <div className={styles.textContainer}>
            <p className={styles.text}>
              Redirecting to the Student Portal. Please do not close the
              window or press back.
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Loading;
